import { render, staticRenderFns } from "./ListadoCarpetas.vue?vue&type=template&id=1aa448c6&scoped=true"
import script from "./ListadoCarpetas.vue?vue&type=script&lang=js"
export * from "./ListadoCarpetas.vue?vue&type=script&lang=js"
import style0 from "./ListadoCarpetas.vue?vue&type=style&index=0&id=1aa448c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa448c6",
  null
  
)

export default component.exports